import { useState } from "react";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  return (
    <div id="contact" className="py-5 bg-light">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          {/* Footer / Contact Info */}
          <div className="col-md-6 mb-4 mb-md-0">
            <div className="d-flex align-items-center">
              <p className="mb-0 text-muted">&copy; 2026 VERIFECH</p>
            </div>
          </div>

          <div className="col-md-6">
            <ul className="list-inline text-md-end mb-0">
              {props.data?.linkedin && (
                <li className="list-inline-item me-4">
                  <a
                    href={props.data.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-dark text-decoration-none"
                    aria-label="LinkedIn"
                  >
                    <i className="fa fa-linkedin fa-lg"></i>
                  </a>
                </li>
              )}
              {props.data?.email && (
                <li className="list-inline-item">
                  <a
                    href={`mailto:${props.data.email}`}
                    className="text-dark text-decoration-none d-flex align-items-center"
                  >
                    <i className="fa fa-envelope-o me-2"></i>
                    <span>{props.data.email}</span>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};